import React from 'react'

import { XIcon } from 'lucide-react'

import { alpha, useTheme, Box, Skeleton, Stack, Typography, IconButton } from '@mui/material'

import { Button } from '@repo/ui'

interface PreviewProps {
  item: any,
  onChange?: any,
  onRemove?: any,
  disabled?: boolean
  children?: React.ReactNode
  rightComponents?: React.ReactNode
  size?: 'small' | 'medium' | 'large'
  sx?: object
}

export const Preview = (props: PreviewProps) => {
  const { item, onRemove = false, size = 'large', onChange = false, disabled = false, rightComponents, sx, children } = props
  const theme = useTheme()

  return (
      <Stack 
        direction="row" 
        alignItems="center" 
        justifyContent="space-between" 
        spacing={3}
        sx={{
          p: size == 'large' ? 3 : size == 'medium' ? 2 : 1, 
          px: 3,
          pr: size == 'large' && 4,
          border:  size == 'large' ? `1px solid ${theme.palette.grey[200]}` : 'none',
          borderRadius: 2,
          width: '100%',
          maxWidth: '100%',
          overflow: 'hidden',
          ...sx
        }}>
          <Stack direction="row" alignItems="center" spacing={size == 'small' ? 2 : 4} sx={{ flex: 1, minWidth: 0 }} >
            {children ? (
              <>
                {children}
              </>
            ) : (
             <Stack spacing={2} sx={{ minWidth: 0, maxWidth: size == 'small' ? 140 : '100%' }}>
               <Typography variant="body2" noWrap>{item}</Typography>
            </Stack>
            )}
          </Stack>
          <Stack spacing={3} direction="row" alignItems="center">
            {rightComponents}
            {onRemove && (
              <IconButton
              color="error"
              aria-label="remove selected"
              onClick={onRemove}
              edge="start"
              sx={{
                color: theme.palette.grey[900],
                '&:hover': {
                  backgroundColor: size == 'large' ? alpha(theme.palette.error.main,.1) : 'transparent',
                  color: theme.palette.error.main
                }            
              }}>
                <XIcon strokeWidth={1}/>
              </IconButton>
            )}
            {onChange && (
              // tertiary (subtle fill) carries the lower-emphasis hierarchy, so the
              // button keeps full height to match the surface's action bar (e.g. the
              // modal's medium 40px Cancel/Transfer) rather than compressing. Compact
              // cards step down to small so it isn't oversized in a tight row.
              <Button
                variant="tertiary"
                size={size === 'large' ? 'medium' : 'small'}
                onClick={onChange}
                disabled={disabled}
              >
                Change
              </Button>
            )}
          </Stack>
        </Stack>
  )
}
interface PreviewLoaderProps {
  children?: React.ReactNode
  size?: 'small' | 'medium' | 'large'
}

export const PreviewLoader = ({ children, size = 'large' }) => {
  return (
    <Box p={3} sx={theme => ({ border: `1px solid ${theme.palette.grey[200]}` })}>
      <Stack spacing={4} direction="row" alignItems="center">
        {children}
      </Stack>
    </Box>
  )
}

